import { diffPaths } from '@/pages/setup-fund/utils/draft-diff';
import type { StepForms } from '@/stores/slices/entity-slice';

import { REVIEW_STEP_PREFIXES } from '../common';

const DIFF_IGNORED_ENTITY_KEYS = new Set([
  'id',
  'isApproved',
  'entityApprovalStatus',
  'draftStatus',
  'logoUrl',
  'previewLogo',
  'isLegalNameCorrect',
  'isDisplayNameCorrect',
  'lastValidatedLegalName',
  'lastValidatedDisplayName',
  'createdAt',
  'updatedAt',
]);

function comparable(forms: StepForms) {
  return Object.fromEntries(
    Object.entries(forms).filter(([key]) => !DIFF_IGNORED_ENTITY_KEYS.has(key)),
  );
}

function matchesPrefix(path: string, prefix: string) {
  return path === prefix || path.startsWith(`${prefix}.`) || path.startsWith(`${prefix}[`);
}

export function countStepChanges(step: number, changedPaths: string[]) {
  const prefixes = REVIEW_STEP_PREFIXES[step] ?? [];

  return changedPaths.filter((path) => prefixes.some((prefix) => matchesPrefix(path, prefix)))
    .length;
}

export function computeEntityDiff(published: StepForms | null, draft: StepForms) {
  const changedPaths = published
    ? Array.from(new Set(diffPaths(comparable(published), comparable(draft)).filter(Boolean)))
    : [];

  const changedCountByStep = Object.fromEntries(
    Object.keys(REVIEW_STEP_PREFIXES).map((step) => [
      Number(step),
      countStepChanges(Number(step), changedPaths),
    ]),
  ) as Record<number, number>;

  return { changedPaths, changedCountByStep };
}

export function changedDirectorUserIds(approved: string[], inDraft: string[]) {
  const approvedSet = new Set(approved);
  const draftSet = new Set(inDraft);

  return new Set(
    [...approved, ...inDraft].filter((id) => !approvedSet.has(id) || !draftSet.has(id)),
  );
}
